var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{staticClass:"button-whatsapp",attrs:{"elevation":"1","icon":""},on:{"click":_vm.redirectWhatsapp}},[_c('v-icon',{attrs:{"color":"#FFFFFF","size":"28px"}},[_vm._v(" mdi-whatsapp ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }